import { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';

/**
 * Hook per gestire gli id delle page presi da URL. Gli ID tornano se definiti e != da 'create',
 * altrimenti trona null.
 */
export function useIdFromUrl<T extends { [K in keyof T]?: string | undefined }>(
  props: Pick<RouteComponentProps<T>, 'match'> | { match: null },
  key: keyof T,
  defaultValue?: string | null,
) {
  const id = useMemo(() => {
    // TODO: ask if create will be translated
    if (props.match?.params?.[key] && props.match.params[key] !== 'create') {
      return props.match.params[key];
    }

    return defaultValue ?? null;
  }, [defaultValue, key, props.match?.params]);

  const isEdit = useMemo(() => id != null, [id]);

  return [id, isEdit] as [string | null, boolean];
}
